import type { LocalMediaFailureReason } from './adapter'

// Причина отказа устройства: getUserMedia и setSinkId бросают DOMException, и
// его `name` — единственный стабильный между браузерами признак, по которому
// можно сказать человеку, что делать (разрешить доступ / закрыть занявшее
// приложение).
export function mediaFailureReason(error: unknown): LocalMediaFailureReason {
  const name = error instanceof Error ? error.name : ''
  switch (name) {
    case 'NotAllowedError':
    case 'SecurityError':
      return 'denied'
    case 'NotReadableError':
    case 'AbortError':
      return 'busy'
    case 'NotFoundError':
    case 'OverconstrainedError':
      return 'missing'
    default:
      return 'unknown'
  }
}
